import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/dashboard/Sidebar";
import ContentGrid from "../components/dashboard/ContentGrid";
import BoardView from "../components/dashboard/BoardView";
import SettingsPage from "../components/dashboard/SettingsPage";

const Dashboard = () => {
  const { user, loading, api } = useAuth();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("library");
  const [activeBoardId, setActiveBoardId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (!loading && !user) navigate("/login");
  }, [user, loading, navigate]);

  useEffect(() => {
    if (user && api) {
      api.get("/categories").then((res) => setCategories(res.data)).catch(() => {});
      api.get("/tags").then((res) => setTags(res.data)).catch(() => {});
    }
  }, [user, api, refreshKey]);

  if (loading) return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="w-6 h-6 border-2 border-white/20 border-t-white rounded-full animate-spin" />
    </div>
  );
  if (!user) return null;

  const handleSectionChange = (section, boardId) => {
    setActiveSection(section);
    if (boardId) setActiveBoardId(boardId);
  };

  const triggerRefresh = () => setRefreshKey((k) => k + 1);

  return (
    <div className="min-h-screen bg-[#050505] flex" data-testid="dashboard">
      <Sidebar
        activeSection={activeSection}
        onSectionChange={handleSectionChange}
        refreshKey={refreshKey}
        categories={categories}
        onCategoriesChange={setCategories}
      />
      <main className="flex-1 min-h-screen overflow-auto">
        {activeSection === "library" && (
          <ContentGrid 
            refreshKey={refreshKey} 
            onRefresh={triggerRefresh} 
            categories={categories} 
            tags={tags}
            onTagsChange={setTags}
            onCategoriesChange={setCategories}
          />
        )}
        {activeSection === "board" && activeBoardId && (
          <BoardView boardId={activeBoardId} onRefresh={triggerRefresh} categories={categories} />
        )}
        {activeSection === "ads" && (
          <ContentGrid 
            refreshKey={refreshKey} 
            onRefresh={triggerRefresh} 
            filterType="ad" 
            categories={categories}
            tags={tags}
            onTagsChange={setTags}
            onCategoriesChange={setCategories}
          />
        )}
        {activeSection === "landing_pages" && (
          <ContentGrid 
            refreshKey={refreshKey} 
            onRefresh={triggerRefresh} 
            filterType="landing_page" 
            categories={categories}
            tags={tags}
            onTagsChange={setTags}
            onCategoriesChange={setCategories}
          />
        )}
        {activeSection === "ugc" && (
          <ContentGrid 
            refreshKey={refreshKey} 
            onRefresh={triggerRefresh} 
            filterType="ugc" 
            categories={categories}
            tags={tags}
            onTagsChange={setTags}
            onCategoriesChange={setCategories}
          />
        )}
        {activeSection === "emails" && (
          <ContentGrid 
            refreshKey={refreshKey} 
            onRefresh={triggerRefresh} 
            filterType="email" 
            categories={categories}
            tags={tags}
            onTagsChange={setTags}
            onCategoriesChange={setCategories}
          />
        )}
        {activeSection === "settings" && (
          <SettingsPage 
            categories={categories} 
            tags={tags}
            onCategoriesChange={setCategories}
            onTagsChange={setTags}
          />
        )}
      </main>
    </div>
  );
};

export default Dashboard;
